'use client';

import { useEffect } from 'react';
import {
  setupConsentListener,
  cleanupConsentListener
} from '@/lib/consent/consent-manager';

/**
 * ConsentWrapper component
 * Sets up CCM19 consent listeners for PostHog and GA4
 * Must be included in root layout
 */
export default function ConsentWrapper() {
  useEffect(() => {
    setupConsentListener();

    return () => {
      cleanupConsentListener();
    };
  }, []);

  return null; // This component doesn't render anything
}
